
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class extends Vue {
  @Prop() private text!: any
  @Prop() private hasMore!: boolean
  @Prop() private fontSize!: string

  detail (id: string) {
    window.location.href = (`/detailPage.html?menuId=${id}`)
  }
}
